/*
 * @Author: liuxiuting
 * @Date: 2022-01-04 15:52:44
 * @LastEditors: wangbaihe
 * @LastEditTime: 2026-03-04 10:31:33
 * @FilePath: \common-mediax\src\apis\ImgLibrary\PhotoLibrarySelection.js
 * @Description:
 *
 * Copyright (c) 2025 by 用户/公司名, All Rights Reserved.
 */
import { createAPI } from '@common'

export default {
  getPhotoApiBase: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0g{jowplf0qipupcbtf', 'post', config, {
      neverLoading: true
    }), // 获取图片库配置
  postPhotoCreate: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0tbwf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }), // 图片创建接口
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0g{jowplf0joju', 'post', config, {
      neverLoading: true
    }), //调用init接口，获取id
  postPhotoPhotofv: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0g{jowplf0qipupgw', 'post', config, {
      neverLoading: true
    }), // 获取图片库文件夹
  postPhotoList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0g{jowplf0qipupmjtu', 'post', config, {
      neverLoading: true
    }), // 获取图片列表 config用于是否展示loading层
  postPhotoGroup: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0g{jowplf0qipuphspvq', 'post', config, vconfig), // 获取组图详情图片列表
  postPhotoGrouplistcount: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0g{jowplf0qipupmjtudpvou', 'post', config, {
      neverLoading: true
    }), // 获取图片库列表数据总数
  postSearchPhotoListCount: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0g{jowplf0tfbsdiqipupmjtudpvou', 'post', config),
  postSearchPhotoList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0g{jowplf0tfbsdiqipupmjtu', 'post', config),
  getE5ImageFile: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60jnbhfgjmf', 'get', config, {
      timeout: 120000,
      ...vconfig
    }), // e5获取图片流中图
  getE5ImageFileOriginal: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0qipupt0psjhjobm', 'get', config, vconfig), // 获取图片流原图
  postPhotosLocalization: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0mpdbmj{bujpo', 'post', config, {
      timeout: 120000
    }), // 保存图片到本地
  getPhotoDrawing: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0esbxjoh', 'get', config), // 抽图接口（仅动作无返回
  getFilesLink: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0gjmft0mjol', 'get', config), // 读文件/图片外链(注意：短时间有效)
  getNewPath: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0qjdGpsxbse0qipup0hfuOfxQbui', 'get', config, {
      timeout: 60000,
      ...vconfig
    }), //获取新图片地址

  // 通用稿库获取图片信息
  getImageInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0buubdinfout0qjdJogp', 'GET', config)
}
